import React, { useRef } from 'react';
import { APPLE_RANK_NAMES } from '../../../../lib/const';
import dateformat from 'dateformat';
import ReactToPrint from 'react-to-print-advanced';
import { ReadingType } from './ReadingType';
import { ReadingBookList } from './ReadingBookList';
import { CategoryGeneral2 } from './CategoryGeneral2';

export const ReadingReport = ({ userReport = null }) => {
    const reportPageRef = useRef(null);

    if (!userReport) return null;

    return (
        <div className="print_viewer" style={{ display: 'block' }} key="report_print">
            <div className="alignR">
                <ReactToPrint copyStyles={true}
                    pageStyle="print_viewer"
                    trigger={() => <button className="btn _red mgB10" ><i className="icon fas fa-print"></i> 출력</button>}
                    content={() => reportPageRef.current} />
            </div>
            <div className="">
                <div className="report_page_wrap" ref={reportPageRef}>
                    <div className="report_page">
                        <h2>나의 독서이력</h2>
                        <p className="desc">독서길라잡이는 꿈씨앗이 꿈나무로 자라는 길을 안내합니다.</p>

                        <div className="report_summary">
                            <div className="user_info">
                                <div className="rank_info">
                                    <img src={`${process.env.PUBLIC_URL}/static/images/user/b0${(userReport.appleRank + 1)}.png`} alt={APPLE_RANK_NAMES[userReport.appleRank]} />
                                    <p><strong>{APPLE_RANK_NAMES[userReport.appleRank]}</strong></p>
                                </div>
                                <div className="student_info">
                                    <span className="name">{userReport.name} </span>
                                    <span className="school">{userReport.school}</span>
                                    <span className="grade"><strong>{userReport.grade}</strong> 학년 <strong>{userReport.class}</strong> 반</span>
                                </div>
                            </div>
                            <div className="report_date">
                                <strong>
                                    {dateformat(userReport.stdate, 'yyyy년 mm월 dd일')} ~ {dateformat(userReport.eddate, 'yyyy년 mm월 dd일')}
                                </strong>
                            </div>
                            <div className="summary">
                                <ReadingType userReport={userReport} />

                                <div className="section">
                                    <h3>독서 분야</h3>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td><CategoryGeneral2 userReport={userReport} /></td>
                                            </tr>
                                            <tr>
                                                <th className="pdT20">독서분야(장르)</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                        <div className="book_list">
                            <table>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>도서명</th>
                                        <th>저자</th>

                                        <th>출판사</th>
                                        <th>사과</th>
                                        <th>퀴즈</th>

                                        <th>감상문</th>
                                        <th>독서화</th>
                                        <th>독서사진</th>
                                        <th>독서영상</th>
                                        <th>책이랑나랑</th>
                                        <th>나도작가다</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ReadingBookList userReport={userReport} />
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );// return 
};